import { useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import { Styles as S } from '~/pages/history/multipleChoice/studyGoal/styles'
import { Button } from '~/shared/components/Button'
import { OptionType } from '~/shared/constants/commonConstants'
import { useNextStep } from '~/shared/hooks/useNextStep'
import { TPageProps } from '~/shared/types/commonTypes'

const QUESTION = 'When do you like to learn?'

const OPTIONS = [
  { key: 'afterMorningCoffee', i18nKey: 'first' },
  { key: 'duringLunchBreak', i18nKey: 'second' },
  { key: 'beforeGoingToSleep', i18nKey: 'third' },
  { key: 'anySpareTime', i18nKey: 'fourth' },
] as const

const LearningTimeArt = ({ nextPagePath, pageId }: TPageProps) => {
  const { t } = useTranslation('art')
  const [answers, setAnswers] = useState<string[]>([])

  const handleOptionChange = (optionValue: string, isChecked: boolean) => {
    setAnswers((prev) =>
      isChecked
        ? [...prev, optionValue]
        : prev.filter((item) => item !== optionValue),
    )
  }

  const handleContinue = useNextStep({
    nextPagePath,
    pageId,
    pageName: pageId,
    question: QUESTION,
  })

  return (
    <S.Root>
      <S.StyledContainer>
        <S.ScrollContent>
          <S.Content>
            <S.Title>
              <Trans ns="art" i18nKey="onboarding.artLearningTime.title" />
            </S.Title>
          </S.Content>

          {OPTIONS.map(({ key, i18nKey }) => {
            const optionText = t(
              `onboarding.artLearningTime.options.${i18nKey}`,
            )
            const spaceIndex = optionText.indexOf(' ')
            const emoji =
              spaceIndex !== -1 ? optionText.slice(0, spaceIndex) : optionText
            const text =
              spaceIndex !== -1 ? optionText.slice(spaceIndex + 1) : ''

            return (
              <S.StyledOption
                key={key}
                type={OptionType.CHECKBOX}
                value={key}
                name="learningTimeArt"
                onChange={handleOptionChange}
                checked={answers.includes(key)}
              >
                <S.Value>
                  <S.OptionIcon>{emoji}</S.OptionIcon>
                  <S.ValueText>{text}</S.ValueText>
                </S.Value>
              </S.StyledOption>
            )
          })}
        </S.ScrollContent>

        <S.ButtonContainer>
          <Button
            type="button"
            onClick={() => handleContinue(answers)}
            disabled={!answers.length}
          >
            <Trans i18nKey="actions.continue" />
          </Button>
        </S.ButtonContainer>
      </S.StyledContainer>
    </S.Root>
  )
}

export default LearningTimeArt
